import React from "react";

export function P(props) {
  return <p className="text-slate-950" {...props} />;
}
